export default {
  graphic: [{}],
}
